import { render, staticRenderFns } from "./MailVerification.vue?vue&type=template&id=3f450697"
import script from "./MailVerification.vue?vue&type=script&lang=js"
export * from "./MailVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports